//external imports
import React, { FunctionComponent, useContext, useEffect, useReducer } from 'react';

import { setDispatch } from './actions';
import PaginationContext from './PaginationContext';
import { paginationReducer } from './reducer';
import { IPaginationStore, IPaginationWrapperProps, IWithPaginationConfig, PaginationReducer } from './types';

//internal imports

//This should only wrap the outermost container in app, does not support multiple instantiations
export const withPaginationProviderWrapper = <P extends IPaginationWrapperProps>(
  Component: FunctionComponent<P>,
  config: IWithPaginationConfig = {}
) => {
  const { reducerFn = (defaultReducer: PaginationReducer) => defaultReducer, Context = PaginationContext } = config;
  const WithPaginationComponent: FunctionComponent<IPaginationStore & P> = props => {
    const { children, ...otherProps } = props;
    const [paginationState, paginationDispatch] = useReducer(reducerFn(paginationReducer), useContext(Context));

    //add the reducer to the store on the initial render
    useEffect(() => {
      setDispatch(paginationDispatch);
    }, []);

    return (
      <Context.Provider value={{ dispatch: paginationDispatch, ...paginationState }}>
        <Component {...(otherProps as P)} dispatch={paginationDispatch}>
          {children}
        </Component>
      </Context.Provider>
    );
  };

  const componentName = Component.displayName || Component.name || 'Component';
  WithPaginationComponent.displayName = `withMsal(${componentName})`;

  return WithPaginationComponent;
};
